import React, { useState } from 'react'
import AuthNavbar from "../components/AuthNavbar/AuthNavbar"
import HomeTitle from "../components/HomeTitle/HomeTitle"
import AddClassForm from "../components/AddClassForm/AddClassForm"
import { Col, Container, Row } from "react-bootstrap"
import { useSelector } from 'react-redux'
import { toast, ToastContainer } from 'react-toastify'
import CustomInput from '../components/CustomInput/CustomInput'
import CustomBtn from '../components/CustomBtn/CustomBtn'
import axios from 'axios'

function SchoolSettings() {
      const { currentLocal } = useSelector((state) => state.currentLocal);
          const userinfo = useSelector((state) => state);
    
      const [id, setId] = useState(null)
      const [key, setKey] = useState(null)
      const [loading, setLoading] = useState('')
    
  const handleSubmit = async (e) => {
    e.preventDefault();
      setLoading(true);


      try {
        const response = await axios.post('https://api.taarteb.com/api/schools/settings', {
          ultramsg_token:key,
          ultramsg_instance_id:id,
     
  
        }, {
          headers: {
            Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
          }
        });
            toast.success("Added Successfully", { position: "bottom-right", autoClose: 3000 });
  
            setKey('')
            setId('')
    
      } catch (error) {
        console.error("Error:", error.response?.data || error.message);
        toast.error(Object.values(error.response.data.errors)[0][0], { position: "bottom-right", autoClose: 3000 });

        
      } finally {
        setLoading(false);
      }


  };
  return (
    <div className="px-0 my-3 w-100 dashboard_content">
      <Container>
        <div className="d-flex flex-column w-100">
          <AuthNavbar />
          <div className="mt-5 mx-3">
            <HomeTitle title={currentLocal.home.add} />

            <div className='add_class_form_container'>
      <ToastContainer />

      <form className='form_container'>
        <Container>
          <Row>
            <Col md={6}>
            <label>Instance ID</label>
            <CustomInput
                        value={id}
                        onChange={(e) => {
                        setId(e.target.value)  
                        }}
                    />
            </Col>
            <Col md={6}>
            <label>Token</label>
            <CustomInput
                        value={key}
                        onChange={(e) => {
                          setKey(e.target.value)  
                        }}
                    />
            </Col>
            <Col md={12}>
              <div className='d-flex justify-content-center mt-4 '>
                <div className='w-50 d-flex justify-content-center'>
                  <CustomBtn text={loading ? currentLocal.home.Loading: currentLocal.home.add} disabled={loading} clickingFunction={handleSubmit} />

                </div>
              </div>
            </Col>
          </Row>
        </Container>

</form>
</div>
          </div>

        </div>
      </Container>
    </div>
  )
}

export default SchoolSettings
